import React, { useState, FormEvent, useEffect } from 'react';

import { FormGroup, Button, HTMLTable, Position, Toaster, Intent, IconName, MaybeElement, Spinner } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";

import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import svgWait2 from '../svg/wait2.gif'
//import tick_circle from '../svg/tick-circle.svg'
import tick_circle from '../svg/checked.svg'
import flow_linear from '../svg/flow-linear.svg'
import svgNotStarted from '../svg/dash.svg'
import svgComleted from '../svg/checked.svg'

import { SystemHeader } from '../CommonUI';


var GsbFlag: any;

interface FBSStatusMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})


export function FBSStatusMini({ gsb }: FBSStatusMainProps) {
    
    
    const imgtick_circle = <img className="tickIcon" src={tick_circle} alt="completed" />
    const imgflow_linear = <img src={flow_linear} alt="Progressing" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />


    const [ShowWait, setShowWait] = useState(true)
    const [ShowRpt, setShowRpt] = useState(false)
    const [ShowNoRecord, setShowNoRecord] = useState(false)


    const [Sys_Start, setSys_Start] = useState(0)
    const [Trade_Reconcilation, setTrade_Reconcilation] = useState(0)
    const [Sys_End, setSys_End] = useState(0)
    const [Daily_Restore, setDaily_Restore] = useState(0)
    const [Daily_ReIndex, setDaily_ReIndex] = useState(0)

    const [xBatch51, setxBatch51] = useState(0)
    const [D_stmt, setD_stmt] = useState(0)
    const [M_stmt, setM_stmt] = useState(0)
    const [Email_stmt, setEmail_stmt] = useState(0)

    const [LuDate, setLuDate] = useState("")
    const [Refresh_min, setRefresh_min] = useState(0)

    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [Enter2tab, setEnter2tab] = useState("Y")

 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag0');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setEnter2tab(GsbFlag.Enter2tab) ;
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, Sys_Start, Daily_Restore, Sys_End, LuDate])

    
    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])


    const refreshTasks = async () => {
        setShowWait(true)
        setShowNoRecord(false)
        setShowRpt(false)

        try {
            const res = await gsb.post('/FBSStatus' )
            if ( res.data.count > 0 ) {
                //console.log("res.data.data: ", res.data.data) 
                //console.log("res.data.data Sys_Start: ", res.data.data[0].Sys_Start) 
                setSys_Start(res.data.data[0].Sys_Start)
                setTrade_Reconcilation(res.data.data[0].Trade_Reconcilation)
                setSys_End(res.data.data[0].Sys_End)
                setDaily_Restore(res.data.data[0].Daily_Restore)
                setDaily_ReIndex(res.data.data[0].Daily_ReIndex)
                //console.log("res.data.data LuDate: ", res.data.now) 

                setxBatch51(res.data.data[0].xBatch51)
                setD_stmt(res.data.data[0].D_stmt)
                setM_stmt(res.data.data[0].M_stmt)
                setEmail_stmt(res.data.data[0].Email_stmt)

                setLuDate(res.data.LuTime)

                setShowWait(false)
                setShowNoRecord(false)
                setShowRpt(true)
            } else {
                setShowWait(false)
                setShowNoRecord(true)
                setShowRpt(false)
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    
    useEffect(() => {
        //console.log("/FBSStatus ") 
        refreshTasks()
    }, [gsb])


    useEffect(() => {
        //console.log("/FBSStatus ") 
        let timer = setInterval(refreshTasks, 120*60*1000)
        setRefresh_min(120)
        if ( Trade_Reconcilation == 2 ) {
            clearInterval(timer)
            timer = setInterval(refreshTasks, 3*60*1000)
            setRefresh_min(3)
        } else if ( Daily_Restore == 1 ) {
            clearInterval(timer)
            timer = setInterval(refreshTasks, 3*60*1000)
            setRefresh_min(3)
        } else if ( Daily_Restore == 2 ) {
            clearInterval(timer)
            timer = setInterval(refreshTasks, 120*60*1000)
            setRefresh_min(120)
        } else if ( Daily_ReIndex == 1 ) {
            clearInterval(timer)
            timer = setInterval(refreshTasks, 3*60*1000)
            setRefresh_min(3)
        } else if ( Daily_ReIndex == 2 ) {
            clearInterval(timer)
            timer = setInterval(refreshTasks, 120*60*1000)
            setRefresh_min(120)
        } else if ( Sys_End == 2 ) {
            clearInterval(timer)
            timer = setInterval(refreshTasks, 120*60*1000)
            setRefresh_min(120)
        } else if ( Email_stmt == 2 ) {
            clearInterval(timer)
            timer = setInterval(refreshTasks, 120*60*1000)
            setRefresh_min(120)
        }
            return () => {clearInterval(timer)
        }
    }, [gsb, Trade_Reconcilation, Daily_Restore, Daily_ReIndex, Sys_End, Email_stmt, Refresh_min])


    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setRefresh_min(0)
        refreshTasks()
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    const statusIcon = (status: number) => {
        //if (status == 1) return <img className="MenuIcon" src={svgRunning} alt="Running" />
        if (status == 1) return <Spinner size={16}/>
        if (status == 2) return <img className="MenuIcon" src={svgComleted} alt="Completed" />
        return <img className="MenuIcon" src={svgNotStarted} />
    }
 
    let list = <>
        <StatusItem icon={statusIcon(Sys_Start)} text="System Start"></StatusItem>
        {/* <StatusItem icon={statusIcon(Trade_Reconcilation)} text="Trade Reconcilation"></StatusItem> */}
        <StatusItem icon={statusIcon(Sys_End)} text="System End"></StatusItem>
        <StatusItem icon={statusIcon(xBatch51)} text="Batch 51"></StatusItem>
        <StatusItem icon={statusIcon(D_stmt)} text="Daily Statement"></StatusItem>
        <StatusItem icon={statusIcon(M_stmt)} text="Monthly Statement"></StatusItem>
        <StatusItem icon={statusIcon(Email_stmt)} text="Send Email Statement"></StatusItem>
        <StatusItem icon={statusIcon(0)} text=""></StatusItem>
        <StatusItem icon={statusIcon(Daily_Restore)} text="Restore"></StatusItem>
        <StatusItem icon={statusIcon(Daily_ReIndex)} text="ReIndex"></StatusItem>
        <hr></hr>
        <div style={{fontSize: 12}}>
            Last Update: {LuDate}<br/>
            * Auto Refresh every {Refresh_min} Mins
        </div>
    </>

    return (
        <>
            <H4>FBS System Status</H4>
            <Button small fill onClick={onSubmit}>Refresh</Button>
            <p></p>
            <div id="DispTrnDate" style={{width: '95%', textAlign: 'right'}}>Tran Date: {TRAN_DATE} </div>
            {ShowWait && <Spinner /> }
            {ShowNoRecord && <p>
                <div style={{fontSize: 12}}>
                    <span id="Err_msg">File FBSSTATUS.LOG cannot be Open</span>
                </div>
            </p>
            }
            {ShowRpt && list}
        </>
    );
}

interface StatusItemProps {
    icon: IconName | MaybeElement
    text: string
}

function StatusItem({icon, text}: StatusItemProps) {
    return <div style={{display: 'flex', flexDirection: 'row', margin: 4}}>
    <div style={{margin: 4}}>{icon}</div>
    <div style={{margin: 4}}>{text}</div>
</div>
}

